import React from "react";

const CardStepTotalZero = () => {
  return (
    <div className="checkout__step-body">
      <div className="my-3">Your credit card won&apos;t be charged.</div>
    </div>
  );
};

export default CardStepTotalZero;
